module.exports = __webpack_public_path__ + "img/14.55e0ad8e.webp";